module.exports = __webpack_public_path__ + "assets/step1Title.b582a713.png";